import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "d-flex justify-content-between flex-fill" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Activities"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Overview of activities")
], -1)
const _hoisted_5 = { class: "card-body py-3" }
const _hoisted_6 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewLogModal = _resolveComponent("ViewLogModal")!
  const _component_ActivitiesTypeDropdown = _resolveComponent("ActivitiesTypeDropdown")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_ActivitiesDataTable = _resolveComponent("ActivitiesDataTable")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ViewLogModal, { data: _ctx.viewedLog }, null, 8, ["data"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_ActivitiesTypeDropdown, {
            modelValue: _ctx.filterType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterType) = $event)),
            class: "w-25"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : (_openBlock(), _createBlock(_component_ActivitiesDataTable, {
              key: 1,
              "table-data": _ctx.data.data,
              onOpenPropertiesModal: _ctx.handlePropertiesModal
            }, null, 8, ["table-data", "onOpenPropertiesModal"])),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Pagination, {
            "total-pages": _ctx.pagination.total_pages,
            "current-page": _ctx.pagination.current_page,
            onChangeCurrentPage: _ctx.handlePageChange
          }, null, 8, ["total-pages", "current-page", "onChangeCurrentPage"])
        ])
      ])
    ])
  ], 64))
}